import React, { MouseEventHandler, VoidFunctionComponent } from "react";
import LoadingProgressiveResource from "@/components/responsive/layout/LoadingProgressiveResource";
import IntersectionObserverSSR from "@/components/responsive/layout/IntersectionObserverSSR";
import { ResponsivePicture } from "@/components/responsive/product/responsivePicture/ResponsivePicture";
import { AdaptiveLoadingResources } from "@/models/scope/productSheet/AdaptiveLoadingResources";

interface Props {
    openModal: MouseEventHandler;
    adaptiveLoadingResources: AdaptiveLoadingResources;
    alt: string;
    media: string;
    isVideoPlayed: boolean;
    isMobile: boolean;
    videoUrl?: string | null;
};

export const ImageSliderItem: VoidFunctionComponent<Props> = ({
    openModal,
    adaptiveLoadingResources,
    media,
    isMobile,
    alt,
    isVideoPlayed,
    videoUrl,
}) => {
    return (
        <div
            className={isVideoPlayed ? "slick-video" : "element"}
            onClick={(e) => {
                !isVideoPlayed ? openModal(e) : null;
            }}
        >
            {isVideoPlayed ?
                <LoadingProgressiveResource resourceName={'Ressource4'}
                    resources={adaptiveLoadingResources}>
                    <IntersectionObserverSSR>
                        <section className="section-video">
                            <iframe width={isMobile ? "100%" : "60%"} height={400}
                                    style={{display: 'block', margin: '0 auto'}} src={`${videoUrl}`} allow="autoplay"/>
                        </section>
                    </IntersectionObserverSSR>
                </LoadingProgressiveResource>
                : <>
                    <ResponsivePicture url={media} alt={alt} isLazy={false} />
                </>}
        </div>
    )
}